import React from "react";

type TagVariant = "navy" | "coral" | "sage" | "outline";

interface TagProps {
  label: string;
  variant?: TagVariant;
  small?: boolean;
}

const variantStyles: Record<TagVariant, string> = {
  navy: "bg-navy text-white",
  coral: "bg-[#FDECE6] text-coral",
  sage: "bg-[#E8F0EE] text-[#4A8075]",
  outline: "bg-transparent border border-light-gray text-warm-gray",
};

function Tag({ label, variant = "outline", small = false }: TagProps) {
  return (
    <span
      className={`
        inline-flex items-center rounded-full font-semibold tracking-wide
        ${small ? "text-[10px] px-[9px] py-[3px]" : "text-[11px] px-3 py-1"}
        ${variantStyles[variant]}
      `}
    >
      {label}
    </span>
  );
}

export default Tag;
